export default __webpack_public_path__ + "static/media/ladder.21708691.png";